import { Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { sharedContent } from 'app/_authenticated/recurring-buys/recurringBuyShared.content';

import { content } from 'app/_authenticated/recurring-buys/route.content';
import { CreateRecurringBuyCard } from '../CreateRecurringBuyCard/CreateRecurringBuyCard';
import { RecurringBuyCard } from '../RecurringBuyCard/RecurringBuyCard';

interface RecurringBuyListEntry {
  id: string;
  productCode: string;
  productName: string;
  amount: string;
  paused: boolean;
  interval: string;
}

export function RecurringBuyList({
  isActiveList,
  list,
  onShowRecurringBuyDetails,
}: {
  isActiveList: boolean;
  list?: RecurringBuyListEntry[];
  onShowRecurringBuyDetails: (recurringById: string) => void;
}) {
  const localizedContent = useContent(content, sharedContent);

  return (
    <>
      <div className="flex flex-col w-full gap-2 lg:max-h-full mb-10">
        <Heading level={4} className="mb-5 text-start shrink-0">
          {isActiveList ? localizedContent.active : localizedContent.paused}
        </Heading>
        {list?.length ? (
          <div className="flex flex-col w-full gap-2 lg:overflow-y-auto">
            {list?.map(e => (
              <RecurringBuyCard
                key={e.id}
                productName={e.productName}
                interval={e.interval}
                productCode={e.productCode}
                amount={e.amount}
                paused={e.paused}
                onShowRecurringBuyDetails={() =>
                  onShowRecurringBuyDetails(e.id)
                }
              />
            ))}
          </div>
        ) : (
          <>
            {!isActiveList && (
              <Typography
                size="large"
                className="text-start items-center h-16 flex flex-row">
                {localizedContent.noPausedRecurringBuys}
              </Typography>
            )}
          </>
        )}
        {isActiveList && (
          <CreateRecurringBuyCard
            heading={localizedContent.createRecurringBuy}
            subHeading={localizedContent.createWeeklyOrMonthly}
          />
        )}
      </div>
    </>
  );
}
